import React, { Component } from 'react';
import './DisposeDrugsPopup.css';
import Popup from '../../components/popup/Popup';
import DrugList from '../../components/drugList/DrugList';
import Card from '../../components/card/Card';
import models from '../../model/models';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import DiscrepancyPopup from '../discrepancyPopup/DiscrepancyPopup';
import mainAPI from '../../api/MainAPI';

export default class DisposeDrugsPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	_confirmDispose = () => {
		window.popupController.show(DiscrepancyPopup, {
			title: 'How are you disposing of these drugs?',
			onComplete: this._complete
		});
	};

	_complete = (value) => {
		let drug_ids = this.drugList.getValue();
		mainAPI.drug.dispose({ drug_ids, notes: value.notes });
	};

	render() {
		return (
			<Popup show className="g-dispose-drugs-popup">
				<Card>
					<DrugList ref={(ref) => (this.drugList = ref)} selectMode drugs={models.drug.objs()} />
					<PrimaryButton onClick={this._confirmDispose}>Dispose</PrimaryButton>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/disposeDrugsPopup/DisposeDrugsPopup.jsx